import type { ActionFunction } from '~/types/route-args';
import type { SetProductInLibraryMutationVariables } from 'generated/graphql';
import { setProductInLibrary } from '~/modules/directory/api/set-product-in-library.server';
import { z } from 'zod';
import * as zfd from 'zod-form-data';
import { UserErrorResponse } from '~/modules/root/graphql/responses';

const SetProductInLibraryInputSchema = z.object({
    productID: zfd.numeric(z.number()),
    // The hook submits the boolean via `fetcher.submit({ inLibrary })` which
    // serialises to the string 'true' or 'false' — coerce at the schema level
    // so the action body can treat it as a boolean directly.
    inLibrary: z.enum(['true', 'false']).transform((v) => v === 'true'),
});

export const action: ActionFunction = async ({ request, context }) => {
    const formData = await request.formData();
    const zfdFormData = zfd.formData(SetProductInLibraryInputSchema);
    const zfdResult = zfdFormData.safeParse(formData);
    if (!zfdResult.success) {
        throw new UserErrorResponse(zfdResult.error);
    }
    const variables: SetProductInLibraryMutationVariables = {
        ProductID: zfdResult.data.productID,
        InLibrary: zfdResult.data.inLibrary,
    };

    return await setProductInLibrary({
        ...context,
        ...variables,
    });
};

export const SET_PRODUCT_IN_LIBRARY =
    '/remix-api/directory/set-product-in-library';
